<template>
    <div>

        <section id="mainContent" class="home" :class="fullHeight"
            :style="{ backgroundImage: `url(${$store.state.clientConfig.directoryUrl}/img/background.png)`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'bottom', backgroundColor: homepageOverrides.backgroundColour }">

            <div class="container">
                <div class="row">
                    <div :class="['col-sm-12 intro', colspanMd]" :style="{ color: homepageOverrides.fontColour }">
                        <h1 :style="{ color: homepageOverrides.h1Colour }" class="mb-4">
                            <template v-if="!homepageOverrides.hideWelcomeToText">Welcome to </template>{{ formatTheSchemeName }}
                        </h1>

                        <p v-if="clientConfig.homepageText === undefined">
                            This website provides you with information about your benefits in the defined benefit section of the
                            {{ clientConfig.fundOrScheme }}. It also allows you to
                            update your details and find other helpful resources. We can't cover everything about your benefits here and sometimes the
                            {{ clientConfig.fundOrScheme }} Rules may change. If there are any differences between the Rules and this website then the Rules
                            will apply.
                        </p>
                        <dynamic-template v-else :template="clientConfig.homepageText" />
                        <dynamic-template :template="homepageCaveat" />

                        <button type="button" class="button-outline-rounded pension mr-3" v-if="!isLoggedIn && showLoginButton" @click="login">Log in</button>
                        <button type="button" class="button-outline-rounded contact" v-if="!disableContactUs" @click="$router.push('/contact')" aria-label="Contact">
                            <mail-icon class="mail-icon" height="25" width="25"></mail-icon>
                        </button>
                    </div>

                    <div class="col-md-5 offset-md-1 col-sm-12 carousel" v-if="clientConfig.homepageWidgets && clientConfig.homepageWidgets.length > 0">
                        <homepageCarousel :widgets="clientConfig.homepageWidgets" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import dynamicTemplate from 'v-runtime-template';
import { MailIcon } from 'vue-bytesize-icons';
import auth from '@/services/authentication';
import homepageCarousel from '@/components/homeCarousel.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'home-view',
    created () {
        this.homepageCaveat = this.$store.getters['clientConfig/clientConfig'].homepageCaveat ? this.$store.getters['clientConfig/clientConfig'].homepageCaveat : '';
        this.modalText = this.homepageOverrides.modalTextOverride ? this.homepageOverrides.modalTextOverride : this.modalText;
    },
    computed: {
        ...mapGetters('clientConfig', [
            'formatTheSchemeName',
        ]),
        colspanMd () {
            return this.$store.state.clientConfig.homepageWidgets && this.$store.state.clientConfig.homepageWidgets.length > 0 ? 'col-md-6' : 'col-md-12';
        },
        primary () {
            return 'rgb(0, 47, 95)';
        },
        clientConfig () {
            return this.$store.getters['clientConfig/clientConfig'];
        },
        isLoggedIn () {
            return this.$store.getters['auth/getAuthState'];
        },
        fullHeight () {
            return this.$store.state.ui.showFooter ? '' : 'full-home-height';
        },
        bespokeHome () {
            return this.$store.state.clientConfig.bespokeHome;
        },
        homepageOverrides () {
            return this.clientConfig.homepage;
        },
        showModal () {
            return this.$store.state.ui.showPopUp;
        },
        showLoginButton () {
            return this.$store.state.clientConfig.disableRegistrationAndLogin !== true;
        },
        disableContactUs () {
            return !!this.$store.state.clientConfig.disableContactUs;
        },

    },
    components: {
        MailIcon,
        dynamicTemplate,
        homepageCarousel,
    },
    methods: {
        closeModal () {
            this.$store.commit('updatePopUp', false);
        },
        login () {
            auth.init();
            this.$store.commit('analytics/setLoggingIn');
            auth.signInSignUp();
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_mixins.scss';

.home {
    height: 100svh;
    position: relative;
    display: flex;
    align-items: center;
    overflow: auto;
    padding-top: $nav-height;

    &.full-home-height {
        min-height: 100svh !important;
        transition: min-height 0.3s ease-in-out;
    }

    @include responsive('md') {
        min-height: 100svh;
        overflow: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 70px;
        bottom: 0;
        display: block;
        padding-bottom: 140px;
        padding-top: 100px;
    }

    @include responsive('sm') {
        min-height: 100svh;
        overflow: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 70px;
        bottom: 0;
        display: block;
        padding-bottom: 140px;
        padding-top: 0;
    }

    &:after {
        content: '';
        background-image: var(--homepageFooter);
        background-size: 100% 100px;
        bottom: 0;
        height: 100px;
        left: 0;
        z-index: 1;
        display: block;
        position: absolute;
        width: 100%;
        pointer-events: none;

        @include responsive('sm') {
            position: fixed;
        }

        @include responsive('md') {
            position: fixed;
        }
    }

    .tesla-bg {
        position: absolute;
        z-index: -1;
        top: 0px;

        &.bg-img {
            max-width: 100%;
        }
    }

    .overlay-colour {
        position: absolute;
        top: 0;
        z-index: 0;
        background: var(--primaryColour);
        opacity: 0.9;
        width: 100%;
        bottom: 0;
    }

    .divider-shape {
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyODAgMTQwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik0xMDk0LjQ0IDExOUwxNzIuNyA2OC43MmE3NC41NCA3NC41NCAwIDAgMS0yNS4xOS01Ljk1TDAgMHYxNDBoMTI4MFYwbC0xMzMuODUgMTAyYy0xNS44NCAxMi4wOS0zMy43IDE3Ljk1LTUxLjcxIDE3eiIgZmlsbC1vcGFjaXR5PSIuNSIvPjxwYXRoIGQ9Ik0xMDkzLjQ4IDEzMS44NUwxNzMgOTRhNzYuODUgNzYuODUgMCAwIDEtMzYuNzktMTEuNDZMMCAwdjE0MGgxMjgwVjBsLTEzMS44MSAxMTEuNjhjLTE2LjQ3IDEzLjk2LTM1LjQ3IDIwLjk2LTU0LjcxIDIwLjE3eiIvPjwvZz48L3N2Zz4=');
        background-size: 100% 100px;
        bottom: 0;
        height: 100px;
        z-index: 1;
        display: block;
        position: absolute;
        width: 100%;
        pointer-events: none;

        @include responsive('sm') {
            display: none;
        }
    }

    ::v-deep.intro {
        color: var(--textOnPrimary);

        z-index: 1;
        align-self: center;

        @include responsive('sm') {
            margin-top: 20px;
            padding: 40px !important;
            margin-bottom: 40px;
        }

        h1 {
            margin-bottom: 30px;
            width: 80%;
            color: var(--secondaryColour);
        }

        p {
            font-size: 18px;
            line-height: 26px;
        }

        .button-outline-rounded {
            border: 2px solid var(--secondaryColour);
            color: var(--textOnSecondary);
            background: var(--secondaryColour);
            padding: 10px 40px;
            text-transform: uppercase;
            display: inline-block;
            border-radius: 30px;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
                color: var(--textOnPrimary);
            }

            &.pension {
                margin-right: 20px;
            }

            &.contact {
                padding: 10px;
            }
        }
    }

    .carousel {
        z-index: 1;
    }
}
</style>
